/* Copyright (C) 2018 HTC Global Services, Inc. - All Rights Reserved  */
import { Directive, Input, ElementRef, AfterViewInit, OnChanges } from '@angular/core';

@Directive({
  selector: '[readMore]'
})

export class ReadMoreDirective implements  AfterViewInit, OnChanges {
  @Input('readMore-length')  private maxLength:     number;
  @Input('readMore-element') private elementChange: HTMLElement;

  private currentText: string;
  private hideToggle:  Boolean = true;
  private text:        string;
  private isCollapsed: Boolean = true;

  constructor(private el: ElementRef) {}

  /**
   * @inheritDoc
   */
  public ngAfterViewInit() {
    this.text = this.elementChange.innerHTML;
    this.toggleView();
    if (!this.hideToggle) {
      this.el.nativeElement.classList.remove('d-none');
    } else {
      this.el.nativeElement.classList.add('d-none');
    }
    this.el.nativeElement.addEventListener('click', (event: MouseEvent) => {
      event.preventDefault();
      this.toggleView();
    });
  }

  /**
   * @inheritDoc
   */
  public ngOnChanges() {
    if (this.text) {
      this.toggleView();
    }
  }
  /**
   * Toogle view - full text or not
   */
  private toggleView(): void {
    this.determineView();
    this.isCollapsed = !this.isCollapsed;
    if (this.isCollapsed) {
      this.el.nativeElement.querySelector('.more').style.display = 'none';
      this.el.nativeElement.querySelector('.less').style.display = 'inherit';
    } else {
      this.el.nativeElement.querySelector('.more').style.display = 'inherit';
      this.el.nativeElement.querySelector('.less').style.display = 'none';
    }
  }

  /**
   * Determine view
   */
  private determineView(): void {
    const _elementChange = document.getElementById(this.elementChange.id);
    if (this.text.trim().length <= this.maxLength) {
      this.currentText = this.text;
      if (_elementChange) {
        _elementChange.innerHTML = this.currentText;
      }
      this.isCollapsed = false;
      this.hideToggle = true;
      return;
    }
    this.hideToggle = false;
    if (this.isCollapsed === true) {
      this.currentText = this.text.substring(0, this.maxLength) + '...';
      if (_elementChange) {
      _elementChange.innerHTML = this.currentText;
      }
    } else if (this.isCollapsed === false)  {
      this.currentText = this.text;
      if (_elementChange) {
      _elementChange.innerHTML = this.currentText;
      }
    }
  }
}
